import { translateFunc } from "client/utils/translateFunc";
import { Loader } from "components/common/Icons/Loader/Loader";
import { RightIcon } from "components/common/Icons/RightIcon";
import { ToolTip } from "components/common/ToolTip/ToolTip";
import { useExportSettings } from "../ExportSettings/useExportSettings";
import { stopPropagation } from "client/utils/stopPropagation";

export const DesktopAction = () => {
    const { validDimensions, unImportedImages, isProcessing, handleProceed, isProceedButtonActive, importedImages } =
        useExportSettings();

    return (
        <ToolTip
            text={
                !validDimensions
                    ? translateFunc("dimensions-error")
                    : unImportedImages.length > 0
                    ? translateFunc("uploading-wait-label")
                    : translateFunc("proceed-to-download-page")
            }
            containerClassNames="w-full"
            inactive={unImportedImages.length + importedImages.length === 0}
        >
            <div
                className={`${
                    isProceedButtonActive
                        ? "cursor-pointer bg-irBlue-200 dark:bg-darkPrimary100 hover:bg-irBlue-400 dark:hover:bg-darkPrimary-200"
                        : "cursor-not-allowed bg-irGray-400 dark:bg-darkSurface-600 hover:bg-irGray-400 dark:hover:bg-darkSurface-500"
                } text-white flex justify-center items-center gap-2 capitalize font-semibold w-full py-4 rounded-xl text-2xl px-1`}
                onClick={stopPropagation(handleProceed)}
                data-testid={`export-button`}
            >
                <div className="select-none">{translateFunc("export")}</div>
                {isProcessing ? (
                    <Loader className="stroke-white" width={24} height={24} />
                ) : (
                    <RightIcon className="fill-white" width={24} height={24} />
                )}
            </div>
        </ToolTip>
    );
};
